import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOneProduct, updateProduct } from 'slice/productSlice';
import { toast } from 'react-toastify';
import { useParams, useNavigate } from 'react-router-dom';

const UpdateProduct = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, data } = useSelector((state) => state.product);

  const [formData, setFormData] = useState({
    name: '',
    sprice: '',
    unit: '',
    offer: '',
    quantity: '',
    long_description: '',
    Updateimage: null,
  });

  useEffect(() => {
    dispatch(getOneProduct(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      setFormData(data);
    }
  }, [data]);

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: type === 'file' ? e.target.files[0] : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formDataToSend = new FormData();
      for (const key in formData) {
        formDataToSend.append(key, formData[key]);
      }
      await dispatch(updateProduct({ id, data: formDataToSend }));
      toast.success('Product updated successfully!');
      navigate('/products');
    } catch (error) {
      console.error('There was a problem updating the product:', error);
    }
  };

  return (
    <div className="container-fluid px-lg-5">
      <div className="mainheadig">
        <h4 className="text-white font-weight-bold">Update Product</h4>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="row p-3">
          <div className="col-sm-4 mt-2">
            <label htmlFor="productName">Product Name</label>
            <input
              type="text"
              id="productName"
              name="name"
              value={formData.name || ''}
              className="form-control"
              onChange={handleChange}
            />
          </div>
          <div className="col-sm-4 mt-2">
            <label htmlFor="productPrice">Product Price</label>
            <input
              type="text"
              id="productPrice"
              name="sprice"
              value={formData.sprice || ''}
              className="form-control"
              onChange={handleChange}
            />
          </div>
          <div className="col-sm-4 mt-2">
            <label htmlFor="productSize">Product Size</label>
            <input
              type="text"
              id="productSize"
              name="unit"
              value={formData.unit || ''}
              className="form-control"
              onChange={handleChange}
            />
          </div>
          <div className="col-sm-6 mt-2">
            <label htmlFor="productOffer">Offer</label>
            <input
              type="text"
              id="productOffer"
              name="offer"
              value={formData.offer || ''}
              className="form-control"
              onChange={handleChange}
            />
          </div>
          <div className="col-sm-6 mt-2">
            <label htmlFor="productQuantity">Quantity</label>
            <input
              type="text"
              id="productQuantity"
              name="quantity"
              value={formData.quantity || ''}
              className="form-control"
              onChange={handleChange}
            />
          </div>
          <div className="col-sm-12 mt-2">
            <label htmlFor="productDescription">Description</label>
            <textarea
              rows={5}
              id="productDescription"
              name="long_description"
              value={formData.long_description || ''}
              className="form-control"
              onChange={handleChange}
            ></textarea>
          </div>
          <div className="col-sm-4 mt-2">
            <label htmlFor="Updateimage">Upload New Image</label>
            <input
              type="file"
              id="Updateimage"
              name="Updateimage"
              className="form-control"
              onChange={handleChange}
            />
          </div>
          <div className="col-sm-4 mt-2">
            {formData.image && (
              <img
                src={`${process.env.REACT_APP_BACKEND}uploads/${formData.image}`}
                className="img-fluid"
                alt="Current Product"
              />
            )}
          </div>
        </div>
        <div className="my-3 text-right">
          <button type="submit" className="btn addbtn" disabled={loading}>
            Update Product
          </button>
        </div>
      </form>
    </div>
  );
};

export default UpdateProduct;
